import { Component, OnInit } from "@angular/core";
import { AppService } from "../../services/app.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-review-sidenav",
  templateUrl: "./review-sidenav.component.html",
})
export class ReviewSidenavComponent implements OnInit {
  selectedlang: any = {};
  tcCode = "";
  currentURL: any = "";
  testCenterName = "";
  constructor(private router: Router, private appservice: AppService) {}

  ngOnInit() {
    if (localStorage.getItem("testCode") != null) {
      this.tcCode = localStorage.getItem("testCode").toString();
    }

    if (localStorage.getItem("testCenterName") != null) {
      this.testCenterName = localStorage.getItem("testCenterName");
    }

    this.appservice.getlang().subscribe((res) => {
      this.selectedlang = res["header"];
    });
    if (sessionStorage.getItem("type")) {
      this.checkURL(sessionStorage.getItem("type"));
    } else {
      this.checkURL("schedule-appointment");
    }
  }

  checkURL(type) {
    sessionStorage.setItem("type", type);
    if (type != null && localStorage.getItem("testCode") != null) {
      if (this.router.url) {
        const url = this.router.url.toString().trim().split("/");
        this.currentURL = url[2];
      }
      if (!this.router.url) {
        setTimeout(() => {
          const url = this.router.url.toString().trim().split("/");
          this.currentURL = url[1];
        }, 100);
      }
    }
  }
}
